import { CustomDomainsApi } from '@va/shared/api/custom-domains';
import { selectAgencyId } from '@va/standalone/shared/selectors';
import { useSelector } from 'react-redux';

export const useActiveSenderEmail = () => {
  const agencyId = useSelector(selectAgencyId);

  const listSenderEmailsReq = CustomDomainsApi.useListSenderEmails(agencyId ? { companyId: agencyId ?? '' } : null);
  return listSenderEmailsReq.data?.active;
};
